<ng-container>
  <div #chartContainer>
    <!-- Id must start with a letter, we arbittrary chose "B" since "A" is taken by linecharts -->
    <figure [id]="'B' + chartId" class="m-0" style="text-align: center"></figure>
  </div>
</ng-container>

<p *ngIf="!hasChartValues">{{ "common.noData" | translate }}</p>
